import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Kicker } from '@/components/Kicker';

export default function AdminErrors() {
  const { t } = useTranslation();
  const q = useQuery({ queryKey: ['admin', 'errors'], queryFn: async () => (await api.get('/admin/errors')).data });
  const items = q.data?.items || [];
  return (
    <section>
      <Kicker>{t('admin.title')}</Kicker>
      <h1 className="mt-3 font-display text-3xl font-semibold text-[#14171C]">{t('admin.nav.errors')}</h1>
      <div className="mt-8 pn-card overflow-hidden">
        <table className="w-full text-left text-sm" data-testid="admin-errors-table">
          <thead className="bg-[#F6F8FB] text-xs uppercase tracking-wide text-[#4A4D52]">
            <tr>
              <th className="px-4 py-3">{t('admin.errors_log.time')}</th>
              <th className="px-4 py-3">{t('admin.errors_log.kind')}</th>
              <th className="px-4 py-3">{t('admin.errors_log.message')}</th>
            </tr>
          </thead>
          <tbody>
            {q.isLoading && <tr><td colSpan={3} className="p-6 text-center text-[#4A4D52]">{t('common.loading')}</td></tr>}
            {items.map((e) => (
              <tr key={e.id} className="border-t border-[#E4E9F0] hover:bg-[#F6F8FB]">
                <td className="px-4 py-3 font-mono text-xs text-[#4A4D52]">{new Date(e.at).toLocaleString()}</td>
                <td className="px-4 py-3"><span className="inline-flex rounded-full bg-[#FBEBEA] px-2 py-0.5 text-xs font-semibold text-[#B42318]">{e.kind}</span></td>
                <td className="px-4 py-3 font-mono text-xs text-[#4A4D52]">{e.message}</td>
              </tr>
            ))}
            {!q.isLoading && items.length === 0 && <tr><td colSpan={3} className="p-6 text-center text-[#4A4D52]">{t('catalog.empty')}</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
